import { FieldError } from 'utils/ValidationError';
import i18Next from 'i18next';

type Props = {
  soldDebtMessage?: string;
};

export function useSoldDebt({ soldDebtMessage }: Props) {
  const getMessage = (soldDebtMsg = soldDebtMessage) => {
    let message: string | undefined;

    if (soldDebtMsg && soldDebtMsg.length) {
      message = '';

      // info from BE splitted with the symbol ";"
      const [, entity, phonesString, emailsString] =
        soldDebtMsg?.split(';') || [];

      // GET COMPANY info
      message += i18Next.t('error:validation.soldDebt.entities', { entity });

      // GET Phone info
      const phones = phonesString?.split(',').filter((p) => p);
      const existsCompanyPhones = phones?.length > 0;

      if (existsCompanyPhones) {
        message += i18Next.t('error:validation.soldDebt.prePhones');
      }

      phones?.forEach((phone: any, indexPhone: any) => {
        const separator =
          indexPhone && indexPhone < phones.length
            ? `${i18Next.t('error:validation.soldDebt.phoneEmailSeparator')}`
            : '';
        message += `${separator}<br /><a href="tel:+34${phone.replaceAll(
          ' ',
          '',
        )}">${phone}</a>`;
      });

      // GET EMAIL info
      const emails = emailsString?.split(',');

      if (emails?.length > 0 && emails?.[0].length) {
        message += existsCompanyPhones
          ? i18Next.t('error:validation.soldDebt.preEmailsWithPhones')
          : i18Next.t('error:validation.soldDebt.preEmailsWithoutPhones');

        emails?.forEach((email: any, indexEmail: any) => {
          const separator =
            indexEmail && indexEmail < emails.length
              ? `${i18Next.t('error:validation.soldDebt.phoneEmailSeparator')}`
              : '';
          message += `${separator}<br /><a href="mailto:${email}">${email}</a>`;
        });
      }
    }
    return message;
  };

  const getSoldDebtMessageFromErrors = (errors?: FieldError[]) => {
    const soldDebtError = errors?.find(
      (error) =>
        error.messageTemplate === 'Forbidden' &&
        error?.message.includes(';') &&
        error?.message?.split(';')[0] === 'sold_debt',
    );
    return getMessage(soldDebtError?.message);
  };

  const message = getMessage();

  return {
    getSoldDebtMessageFromErrors,
    message,
  };
}
